import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { Form, Button, Card, Container, Alert } from 'react-bootstrap';
import { authService } from '../../services/authService';
import './LoginPage.css';

const EsqueciSenhaPage: React.FC = () => {
    const history = useHistory();
    const [email, setEmail] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [success, setSuccess] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);

        try {
            await authService.esqueciMinhaSenha(email);
            setSuccess('Se este email estiver cadastrado, você receberá as instruções para redefinir sua senha.');
            // Don't auto-redirect, let user click button instead
        } catch (err) {
            setError('Erro ao processar sua solicitação. Por favor, tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center min-vh-100">
            <Card className="login-card">
                <Card.Body>
                    <Card.Title className="text-center mb-4">Esqueci minha senha</Card.Title>
                    {error && <Alert variant="danger">{error}</Alert>}
                    {success && (
                        <Alert variant="success">
                            <div className="mb-3">{success}</div>
                            <div className="d-flex justify-content-center">
                                <Button
                                    variant="outline-success"
                                    onClick={() => history.push('/login')}
                                    className="btn-sm"
                                >
                                    Ir para o Login
                                </Button>
                            </div>
                        </Alert>
                    )}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Digite seu email cadastrado"
                                required
                            />
                            <Form.Text className="text-muted">
                                Informe o email cadastrado para receber as instruções de recuperação de senha.
                            </Form.Text>
                        </Form.Group>

                        <Button
                            variant="primary"
                            type="submit"
                            className="w-100 mb-3"
                            disabled={loading}
                        >
                            {loading ? 'Enviando...' : 'Enviar instruções'}
                        </Button>

                        <div className="text-center">
                            <Link to="/login" className="text-decoration-none text-secondary">
                                Voltar para o login
                            </Link>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default EsqueciSenhaPage;
